<ion-header>
  <app-page-header popoverCssClass='resources'></app-page-header>
  <app-resources-header [title]='"Teaching Tools"' [searchPlaceholder]='"Search Teaching Tools"' (searchTextChanged)='onSearchTextChanged($event)' [sortItems]='sortItems' [selectedSortName]='sortName' [showSort]='false'></app-resources-header> 
</ion-header>

<ion-content appScrollBounce>
    <div class='bottom'>
      <div [ngClass]="['contents', resourcesCssService.responsiveClass()]">
        <app-spinner-overlay [spinning]='!viewDisplayed'></app-spinner-overlay>
        <app-resources-filter [hidden]='!viewDisplayed' [filters]=filters></app-resources-filter>
        <div class='items'>
        <div class='list'>
          <ng-container *ngFor='let tool of listItems; trackBy: trackByUuid'>
            <app-teaching-tool [tool]='tool'></app-teaching-tool>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</ion-content>